import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const Impressum = () => {
  return (
    <div className="bg-background pb-20">
      <main className="container mx-auto px-4 pt-24 max-w-3xl">
        <Card>
          <CardHeader>
            <CardTitle className="text-3xl font-bold">Impressum</CardTitle>
          </CardHeader>
          <CardContent className="prose dark:prose-invert max-w-none space-y-6">
            <section>
              <h2 className="text-xl font-semibold mb-2">Angaben gemäß § 5 TMG</h2>
              <p>
                Ramon Cemil Kimyon<br />
                Theodor-Heuss-Straße 13<br />
                37075 Göttingen
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-2">Kontakt</h2>
              <p>
                E-Mail: info@scherenmarket.de
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-2">Redaktionell verantwortlich</h2>
              <p>
                Ramon Cemil Kimyon<br />
                Theodor-Heuss-Straße 13<br />
                37075 Göttingen
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-2">EU-Streitschlichtung</h2>
              <p>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
                  https://ec.europa.eu/consumers/odr/
                </a>.<br />
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-2">Verbraucherstreitbeilegung/Universalschlichtungsstelle</h2>
              <p>
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default Impressum;
